import { FetchClient } from "./FetchClient";

export class HttpAdapter {
    constructor(HttpClient = new FetchClient()) {
        this.HttpClient = HttpClient;
    }

    async call(url, params = {}, configs = {}) {
        return await this.HttpClient.call(url, params, configs);
    }
}
